module.exports = __webpack_public_path__ + "ico-chat.3cba894a.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/components/Chat/imgs/ico-chat.svg
// module id = 1570
// module chunks = 0